/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_NO_CUSTOMER = 'SET_NO_CUSTOMER';
export const GET_ALL_CUSTOMERS = 'GET_ALL_CUSTOMERS';
export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER';
export const REMOVE_CUSTOMER = "REMOVE_CUSTOMER";
